import React from 'react'
import { Box } from '@mui/system'
import { useTheme } from '@mui/material'
import { ALPHABET } from '../../../../utils/constants'
import { AnswerState } from '../../../../features/types'
import { tone, ui } from '../../../../utils/uiTokens'

interface Props {
    answer: AnswerState
    selected: boolean
    index: number
}

const ResultOption: React.FC<Props> = ({ answer, index }) => {
    const theme = useTheme()

    const styles = {
        wrapper: {
            display: 'flex',
            alignItems: 'start',
            cursor: 'pointer',
            mb: 1,
        },
        optionLetter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            mr: 1,
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: answer.correct
                ? tone.ok.bg
                : answer.isChecked
                ? tone.bad.bg
                : ui.card,
            border: answer.correct
                ? `1px solid ${tone.ok.border}`
                : answer.isChecked
                ? `1px solid ${tone.bad.border}`
                : `1px solid ${theme.palette.grey[200]}`,
        },
        optionText: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            minHeight: '24px',
            p: 1,
            background: answer.correct
                ? tone.ok.bg
                : answer.isChecked
                ? tone.bad.bg
                : ui.card,
            borderRadius: '8px',
            border: answer.correct
                ? `1px solid ${tone.ok.border}`
                : answer.isChecked
                ? `1px solid ${tone.bad.border}`
                : `1px solid ${theme.palette.grey[200]}`,
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.optionLetter}>{ALPHABET[index].name}</Box>

            <Box
                sx={styles.optionText}
                dangerouslySetInnerHTML={{ __html: answer.content }}
            />
        </Box>
    )
}

export default ResultOption
